import { ReactNode } from "react";
import { FormItem, Checkbox, CheckboxProps } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useField } from "formik";

type CheckboxFieldProps = {
  name: string;
  label?: string;
  valueConverter?: {
    fromValueToBoolean: (fromValue: any) => boolean | undefined;
    fromBooleanToValue: (booleanValue?: boolean) => any;
  };
  info?: ReactNode;
};

export const CheckboxField = (props: CheckboxFieldProps & CheckboxProps) => {
  const { t } = useTranslation();
  const { name, label, valueConverter, info, ...checkboxProps } = props;
  const [field, meta, { setValue }] = useField(name!);

  const hasFeedback = !!(meta.touched && meta.error);
  const help = meta.touched && meta.error && t(meta.error);
  const validateStatus = meta.touched && meta.error ? "error" : undefined;

  const isChecked = valueConverter
    ? valueConverter.fromValueToBoolean(meta.value)
    : meta.value;

  return (
    <FormItem
      help={hasFeedback ? help : undefined}
      validateStatus={validateStatus}
      label={label}
      info={info}
    >
      <Checkbox
        {...checkboxProps}
        {...field}
        checked={isChecked}
        onChange={(e) => {
          const value = e.target.checked;

          const convertedValue = valueConverter
            ? valueConverter.fromBooleanToValue(value)
            : value;

          setValue(convertedValue);
        }}
      />
    </FormItem>
  );
};
